<template>
  <div class="memory-other">
    <div class="memory" id="memory" ref="gasmemoryline"></div>
    <div class="memory-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <!-- <div class="date-box">
        <div class="left">
          <span></span>
          <span>总使用率</span>
        </div>
        <div class="right">
          <span>6.40%</span>
          <span>7.15%</span>
          <span>6.79%</span>
          <span>6.40%</span>
        </div>
      </div> -->
       <div class="date-box">
        <div class="left">
          <span style="background:#ffa800"></span>
          <span>可用</span>
        </div>
        <div class="right">
          <span>{{this.needData.unUsed.Min}}%</span>
          <span>{{this.needData.unUsed.Max}}%</span>
          <span>{{this.needData.unUsed.Mvg}}%</span>
          <span>{{this.needData.unUsed.Curant}}%</span>
        </div>
      </div>
       <div class="date-box">
        <div class="left">
          <span style="background:#00d8ff"></span>
          <span>已用</span>
        </div>
        <div class="right">
          <span>{{this.needData.unUsed.Min}}%</span>
          <span>{{this.needData.unUsed.Max}}%</span>
          <span>{{this.needData.unUsed.Mvg}}%</span>
          <span>{{this.needData.unUsed.Curant}}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props:['needData'],
  mounted() {
    // setTimeout(()=>{
    //    this.memory(this.needData);
    // },200)
   this.memory(this.needData);
  },
  // watch: {
  //   'needData'() {
  //     this.memory(this.needData);
  //   },
  // },
  methods: {
    memory(param) {
      let myEchart = this.$echarts.init(document.getElementById("memory"));
      //  console.log(param);
      var name = [];
      var Used = [];
      var unUsed = [];
      var total = [];
      param.List.forEach((item) => {
        name.push(item.name);
        Used.push(item.Used);
        unUsed.push(item.unUsed);
        total.push(item.total);
      });
      let option = {
        color: ["#dba53f", "#59ddfe", "#daf6fd"],
        grid: {
          top: "13%",
          left: "8%",
          right: "4%",
          bottom: "35%",
        },
        xAxis: [
          {
            nameLocation: "end",
            nameTextStyle: {
              fontSize: 10,
              color: "#b9bec6",
              padding: [0, 0, 0, 0],
            },
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#5b7486",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#b9bec6",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#587485",
              },
            },
            boundaryGap: false,
            data: name,
          },
        ],

        yAxis: [
          {
            type: "value",
            name: "(GB)",

            nameTextStyle: {
              color: "#b9bec6",
              fontSize: 10,
              padding: [0, 20, 0, 0],
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#5b7486",
                fontSize: 12,
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#587485",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#b9bec6",
              },
            },
          },
        ],
        series: [
          {
            name: "最低",
            type: "line",
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 4,
                color: "#00d8ff",
              },
            },

            data: Used, //data.values
          },
          {
            name: "标准",
            type: "line",
            showSymbol: false,

            lineStyle: {
              normal: {
                width: 4,
                color: "#ffa800",
              },
            },

            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(75,82,84,.9)",
                    },
                    {
                      offset: 1,
                      color: "rgba(75,82,84,.9)",
                    },
                  ],
                  false
                ),
              },
            },
            data:unUsed, //data.values
          },
          // {
          //   name: "最高",
          //   type: "line",
          //   showSymbol: false,

          //   lineStyle: {
          //     normal: {
          //       width: 4,
          //       color: "#ff2929",
          //     },
          //   },

          //   data: total, //data.values
          // },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.memory {
  width: 100%;
  height: 100%;
  position: relative;
}

.memory-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.memory {
  width: 100%;
  height: 100%;
}

.memory-box {
  width: 95%;
  height: 7.5vh;
  position: absolute;
  bottom: 0;
  left: 3%;
  
}
.memory-box .date {
  width: 100%;
  height: 1.2vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.memory-box .date div {
  width: 44%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
.memory-box .date div span {
  height: 100%;
  margin-right: 1.14vw;
  transform: scale(0.7);
  line-height: .6vw;
}

.memory-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url('../../assets/img/74.png');
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .6vw;
  margin-top: .5vh;
}

.memory-box .date-box .left {
  width: 16%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  margin-left: 1vw;
}

.memory-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: .7vh;
  background: red;
  
}
.memory-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
  margin-left: .5vw;
}

.memory-box .date-box .right {
  width: 32%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aebfc4;
  margin-right: 2.5vw;
}
</style>